import { useRef, useCallback } from 'react';
import { useQueuedEventStore ,addEventParam} from '@ninjacart/nc-events-sdk-v2';
import { IAdaptiveActionCard } from '@ninjacart/nc-nk-core';
import { KissanEventType } from '@ninjacart/nc-nk-store';

export const useEventTracking = (pageName?: string) => {
  const enqueue = useRef(useQueuedEventStore((state) => state.enqueue)).current;

  const trackItemClick = useCallback(
    (item: IAdaptiveActionCard, currentTime: number) => {
      const additionalDetails = [
        addEventParam('itemId', item.actionData?.content?.id),
        addEventParam('postOwnerId', item.actionData?.content?.postOwnerId),
        addEventParam('mediaURL', item?.actionData?.mediaDetails[0]?.mediaUrl),
        addEventParam('videoId', item.actionData?.content?.id),
        addEventParam('recommendationId', item.actionData?.content?.recommendationId),
        addEventParam('itemIndex', item.actionData?.content?.itemIndex),
        addEventParam('eventId', item.actionData?.content?.eventId ?? ''),
      ];

      const eventToEnqueue = {
        name: pageName ? KissanEventType.PROFILE_OTHERS_ITEM_CLICK : KissanEventType.ITEM_CLICKED,
        screenDetails: { screen: 'feed video page' },
        eventParams: additionalDetails,
      };

      enqueue(eventToEnqueue);

      return {
        userHistory: {
          currentTime: currentTime ?? 0,
        },
      };
    },
    [enqueue, pageName]
  );

  return {
    trackItemClick,
  };
}; 